export default __webpack_public_path__ + "static/media/hero-bg-1@2x.37473374.webp";